import { Config } from '@chegg-wt/core/config'
import { FetchUserResponse, User } from '@chegg-wt/core/types/auth'
import { requestWithCredentials } from '@chegg-wt/core/utils/api'
import { getCurrentTime } from '@chegg-wt/core/utils/dateTime'
import {
  removeSessionStorageItem,
  SESSION_STORAGE_KEYS,
} from '@chegg-wt/core/utils/sessionStorage'
import { Cookies, getCookie } from '@chegg-wt/core/utils/cookies'

const debouncePromise = require('debounce-promise')

function getUserAndTokenPromise() {
  const tokenUrl =
    getCookie(Cookies.OneAuth) === 'true'
      ? `${Config.tokenUrl}&oneauth=true`
      : Config.tokenUrl
  return Promise.resolve<FetchUserResponse>(requestWithCredentials(tokenUrl, 'get'))
}

// Debounced version of getUserAndToken
const debouncedGetUserAndTokenPromise = debouncePromise(getUserAndTokenPromise, 200)

// Returns a new user token
// Multiple calls are debounced
export async function getUserAndToken(): Promise<User> {
  const response = await debouncedGetUserAndTokenPromise()
  removeSessionStorageItem(SESSION_STORAGE_KEYS.fetchingToken)
  return { ...response, exp: getCurrentTime() + 60 }
}
